import React, { useEffect, useState } from "react";
import { getMyInfo } from "services/admin/adminService"; 
import "./myAccount.scss"

const MyAccount = () => {
  const token = localStorage.getItem("token");
  const [adminInfo, setAdminInfo] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getMyInfo(token);
      setAdminInfo(data.data);  // Cập nhật state với dữ liệu người dùng
    };

    fetchData();
  }, [token]);

  return (
    <div className="container">
      <div className="content-box"> {/* Thêm thẻ div này */}
        {/* <h1>My Account</h1> */}
        {adminInfo ? (
          <div>
            <p>Email: {adminInfo.email}</p>

            <h4>Quyền quản lý:</h4>
            <p>
           {adminInfo.permissions &&
                adminInfo.permissions.map((permission) => permission.desc).join(", ")}
            </p>
          </div>
        ) : (
          <p className="loading-message">Loading user information...</p>
        )}
      </div>
    </div>
  );
};

export default MyAccount;
